import { useContext } from 'react';
import { I18nContext } from '../../contexts/i18n/i18n-context-instance';
import type { I18nContextValue } from '../../types/i18n/i18n.type';

/**
 * Hook to access the i18n context for translations and language management.
 *
 * Provides access to the current language, translation function, client type,
 * and language setter. Must be used within an I18nProvider.
 *
 * @returns The I18nContextValue containing translation utilities and current language state
 * @throws Error if used outside of an I18nProvider
 *
 * @example
 * ```tsx
 * const { t, language, setLanguage } = useI18n();
 * return <div>{t('common.hello')}</div>;
 * ```
 */
export const useI18n = (): I18nContextValue => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};
